import { Setting } from "./content";

export enum ItemStatus {
  DRAFT = "draft",
  REVIEWING = "reviewing",
  PREPARING = "preparing",
  DELIVERED = "delivered",
  PAID = "paid",
}

export interface Item {
  id: string;
  title: string;
  isPublished: boolean;
  orderNumber: number;
  price: number;
  description: string;
  images: string[];
  elements: string[];
  createdBy: string;
  status: ItemStatus;
  quantity: number;
}

export interface OrderItem extends Pick<Item, "id" | "title" | "price" | "status"> {
  id: string;
  itemId: string;
  quantity: number;
  settings?: Setting[];
  comments?: string;
}
